var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1464 3.14645C10.3417 2.95118 10.6583 2.95118 10.8536 3.14645L13.3536 5.64645C13.5488 5.84171 13.5488 6.15829 13.3536 6.35355L6.85355 12.8536C6.75979 12.9473 6.63261 13 6.5 13H4C3.72386 13 3.5 12.7761 3.5 12.5V10C3.5 9.86739 3.55268 9.74021 3.64645 9.64645L10.1464 3.14645ZM4.5 10.2071V12H6.29289L12.2929 6L10.5 4.20711L4.5 10.2071Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEdit);
export default __webpack_public_path__ + "static/media/whiteEdit.107bc95eff08a7539c945ff9a2a34bf1.svg";
export { ForwardRef as ReactComponent };